import { AfterViewInit, Component, OnInit,  HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxOtpInputConfig } from 'ngx-otp-input';
import { Observable, timer, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';
import { HttpService } from '../../services/main_local.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';



@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],

})
export class OtpComponent implements OnInit,AfterViewInit {


  countDown: Subscription;
  counter :any;
  tick:any;
  isForgotPassword: boolean = false;
  isOtp:boolean = true;
  validOtp:boolean = true;
  errorStatus:any = "success";
  loginForm!: FormGroup;
  mobileNumber:any;
  otp:any;
  authToken: any = null; 
  countryCode:any = '+678'
  isHandset$: Observable<boolean> = this.sharedService.isHandset()
  otpInputConfig: NgxOtpInputConfig = {
    otpLength: 6,
    autofocus: true,
    classList: {
      inputBox: 'my-super-box-class',
      input: 'my-super-class',
      inputFilled: 'my-super-filled-class',
      inputDisabled: 'my-super-disable-class',
      inputSuccess: 'my-super-success-class',
      inputError: 'my-super-error-class',
    },
  };

  constructor(
     private fb: FormBuilder,
     private router : Router,
     private route : ActivatedRoute,
     private dialog : MatDialog,
     private httpService : HttpService,
     private snackBar:MatSnackBar,
     private spinner: NgxSpinnerService,
     private sharedService : SharedService) { 

    }
    @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
      let result = confirm("Changes you made may not be saved.");
      if (result) {
        // Do more processing...
      }
      event.returnValue = false; // stay on same page
    }

  hide = true;
  ngOnInit(): void {
    this.loginForm = this.fb.group({
    });
    this.route.queryParams.subscribe((params) => {
      this.mobileNumber = params['mob']; 
    });
    this.countTimer();
    this.loginForm.setErrors({ 'invalid': false });
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }

  countTimer(){
    this.counter = 120;
    this.tick =1000;
    this.countDown = timer(0, this.tick)
    .pipe(take(this.counter))
    .subscribe(() => {
      --this.counter;
      if (this.counter == 0) {
        this.countDown.unsubscribe();
      }
    });
  } 
  
  ngAfterViewInit(): void {
    console.log("afterViewInit");
  }


  handeOtpChange(value: any): void {
    this.validOtp = true;
    if(value[5] != null && value[5] != ''){
      this.isOtp = false;
    } else {
      this.isOtp = true;
    }
  }

  handleFillEvent(value: any): void {
    this.otp = value;
    this.isOtp = false;
    this.errorStatus = "error"
  }

  onVerify(){
    this.spinner.show();
    const body: any = {
      "isdCode": this.countryCode,
      "mobileNumber": this.mobileNumber,
      "otp": this.otp,
      "isMobile": false
    }
    this.httpService.postRequestCall('auth/otp', body, this.authToken, {}).subscribe({
      next: (value)=>{
        this.spinner.hide();
        let data:any = value;
        this.snackBar.open((data?.message), '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3 * 1000,
        });
        this.router.navigate(['set-password'],{relativeTo:this.route,queryParams:{mob:this.mobileNumber}});
      },
      error:(err)=>{
        this.validOtp = false;
        this.errorStatusFun(err);
      }
    })
  }

  onResend() {
    if(window.navigator.onLine) {
    this.spinner.show();
    const body: any = {
      "mobileNumber": this.mobileNumber,
      "isdCode": this.countryCode,
      "isMobile": true,
      "forgotPass": false
    }
    this.httpService.postRequestCall('auth/verifyUser', body, this.authToken, {}).subscribe({
      next: (value)=>{
        this.spinner.hide();
        let data:any = value;
        this.snackBar.open('OTP sent to your registered contact detail', '', {
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
          duration: 3 * 1000,
        });
        this.countTimer();
      },
      error:(err)=>{
        this.errorStatus(err);
      }
    })
  } else {
    this.snackBar.open('Please check your internet connection', '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3 * 1000,
    });
  }
}


  back() {
    this.router.navigate(['login']);
  }

  errorStatusFun(error:any){
    this.spinner.hide();
    this.snackBar.open((error.error.message), '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 3 * 1000,
    });
  }
  

}
